import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Typography,
    Button,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Chip,
} from '@mui/material';

const MAX_PREVIEW_ROWS = 10;

export default function ImportStepPreview({ headers, rows, onBack, onNext }) {
    const [t] = useTranslation();
    const previewRows = rows.slice(0, MAX_PREVIEW_ROWS);

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Typography variant="body1">
                    {t('Review your data before importing.')}
                </Typography>
                <Chip
                    label={`${rows.length} ${t('rows')}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                />
            </Box>

            <TableContainer sx={{ maxHeight: 360, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            {headers.map((h) => (
                                <TableCell key={h} sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                                    {h}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {previewRows.map((row, i) => (
                            <TableRow key={i} hover>
                                {headers.map((h) => (
                                    <TableCell key={h} sx={{ whiteSpace: 'nowrap' }}>
                                        {row[h]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {rows.length > MAX_PREVIEW_ROWS && (
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    {t('Showing first {{count}} of {{total}} rows', {
                        count: MAX_PREVIEW_ROWS,
                        total: rows.length,
                    })}
                </Typography>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button onClick={onBack} color="inherit">
                    {t('Back')}
                </Button>
                <Button variant="contained" onClick={onNext}>
                    {t('Confirm Import')}
                </Button>
            </Box>
        </Box>
    );
}
